import { useCarContext } from 'context/carStore'
import InspectionReport from 'components/InspectionReport'
import { pdf } from '@react-pdf/renderer'
import { getDamagedParts } from 'constants/technicalInspection'

const downloadRenderedPDF = async (pdfComponent, title) => {
  try {
    const blob = await pdf(pdfComponent).toBlob()

    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = title
    a.click()
    URL.revokeObjectURL(a.href)
    a.remove()
  } catch (error) {
    console.error(error)
  }
}

export default function useDownloadPDF() {
  const { techState, car } = useCarContext()

  const marka = car?.marka.name
  const model = car?.model.name
  const year = car?.year
  const vin = car?.vin

  const carInfo = {
    marka,
    model,
    year,
    vin
  }

  const damagedParts = techState ? getDamagedParts(techState) : null

  const downloadInspectionReport = () => {
    downloadRenderedPDF(
      <InspectionReport
        {...{
          techState,
          damagedParts
        }}
        selectedCar={carInfo}
      />,
      `Акт осмотра товара ${marka} ${model} ${year}.pdf`
    )
  }

  return { downloadInspectionReport }
}
